import { defineComponent as _defineComponent } from 'vue'
import { provide, ref } from 'vue';
import AlertModal from './components/modals/AlertModal.vue';
import LoadingModal from './components/modals/LoadingModal.vue';
import { AlertModalInjection, LoadingModalInjection } from './infra/constants/injections';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

const alertModal = ref<InstanceType<typeof AlertModal>>();
const loadingModal = ref<InstanceType<typeof LoadingModal>>();

provide(AlertModalInjection, alertModal);
provide(LoadingModalInjection, loadingModal);


const __returned__ = { alertModal, loadingModal, AlertModal, LoadingModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})